import "google-fonts";
import "regenerator-runtime/runtime";

import Bodycomponent from "./component/bodycomponent.js";
import ChatBot from "./component/chatbot/ChatBot.jsx";

import React, { useRef, useState, useEffect } from "react";
import "./App.css";
import { db } from "./config/firebase";

import { getDoc, doc } from "firebase/firestore";

function App() {
  const [float_visible, setfloat_Visible] = useState(true);
  const [isLoading, setIsLoading] = useState(true); // Add loading state
  const [imageUrl, setImageUrl] = useState();
  const [title, setTitle] = useState();
  const [defualtMessages, setDefualtMessages] = useState([]);
  const [submenu, setSubmenu] = useState([]);
   const [showPopup, setShowPopup] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const currentDomain = urlParams.get("parentUrl");
  const exactParentDomain = urlParams.get("currentUrl");
  // console.log("-----------------------------------------------", currentDomain, "--------------------------------------");
  const shopId = currentDomain || "null";
 const isGetMyCouch = currentDomain && (currentDomain.includes("getmycouch") || currentDomain.includes("quick"));
    const handleVisitStore = () => {
    setShowPopup(true);
  };
  const closePopup = () => {
    setShowPopup(false);
  };


  const handleWhatsAppClick = () => {
  
    const urlParams = new URLSearchParams(window.location.search);
    const full_url= urlParams.get("currentUrl")
    // get url before any extra params
    const new_domain = full_url.split('?')[0].split('#')[0];
 
    if (full_url.includes("utm_source=google")){
      // here needs to add some 
      const current_url= new_domain+"?utm_source=google"
      
       window.open(
      "https://api.whatsapp.com/send?phone=917011289722&text=Hi%2C%20can%20you%20tell%20me%20the%20best%20offers%20on%20"+current_url,
      "_blank"
    );

    }else{
  window.open(
      "https://api.whatsapp.com/send?phone=917011289722&text=Hi%2C%20can%20you%20tell%20me%20the%20best%20offers%20on%20"+new_domain,
      "_blank"
    );
    }
  
  };
    const handleGetDirections = (location) => {
    const addresses = {
      noida: "Plot No 8, Sector 75, Opposite Of Indosham 75 Apartment, Noida",
      gurgaon: "2nd Floor, Vishal Tower, Sector 52, Opposite Of Tau Devi Lal Park, Gurugram"
    };
    
    const address = addresses[location];
    if (location === "noida") {
      const mapsUrl = `https://www.google.com/maps/place/GetMyCouch/@28.579049,77.3778797,661m/data=!3m1!1e3!4m6!3m5!1s0x390cefb4e3fb4b63:0xabc680eef1cdb0ac!8m2!3d28.5790353!4d77.3827598!16s%2Fg%2F11y3wns_v_?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoASAFQAw%3D%3D`;
    window.open(mapsUrl, "_blank");
    }
    if (location === "gurgaon") {

      const mapsUrl = `https://www.google.com/maps/place/GetMyCouch/@28.4368213,77.0899378,662m/data=!3m2!1e3!4b1!4m6!3m5!1s0x390d1ed27917d8e1:0x9b11716c90b009a7!8m2!3d28.4368213!4d77.0899378!16s%2Fg%2F11cn3pqz4p?entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoASAFQAw%3D%3D`;
    window.open(mapsUrl, "_blank");
    }
    
  };
  useEffect(() => {
    const fetchImage = async () => {
      try {
        // Replace `collectionName` and `documentId` with your Firestore structure
        const docRef = doc(db, "Shopify", shopId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setImageUrl(docSnap.data().Avatar_Link || "https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/whatsapp-media%2Fbot.png?alt=media&token=dee0144e-14ca-4e2d-99e8-ad03a6618559");
          setTitle(docSnap.data()?.Botname || "");
          const actionButtons = docSnap.data()?.ActionButtons ?? {}

          const submenu = docSnap.data()?.Submenu ?? []
          // console.log("this is submenu", submenu)

          setDefualtMessages(actionButtons)
         
          // here if exactParentDomain is available, and it contains /products/ then take action buttons from feild ProductButtons
          if (exactParentDomain && exactParentDomain.includes("/products/")) {
            const productButtons = docSnap.data()?.ProductButtons || [];
            setDefualtMessages(productButtons);
          }
         
          setSubmenu(submenu)
          
          const all_colors = docSnap.data()?.Color_Theme || {};
          const headerbackground = all_colors.primaryColor ?? "#dcf2d9";
          const headertext = all_colors.textSecondaryColor ?? "#000000";
          const bubble_user = all_colors.secondaryColor ?? "#3b892e";
          const send_button = all_colors.buttonTextColor ?? "#000";
          const footercolor = all_colors.primaryColor ?? "#5c583b";
          const textcolor = all_colors.textPrimaryColor ?? "#000000";
          const primarycolor = all_colors.primaryColor ?? "#000000";
          const accentColor = all_colors.accentColor ?? "#3b892e";
          const bubble_Sender = all_colors.bubble_Sender ?? "#000";
    
          const wholesectionbackground = all_colors.backgroundColor ?? "#fff";

          document.documentElement.style.setProperty("--color-text", textcolor);
          document.documentElement.style.setProperty("--color-bubble", bubble_user);
          document.documentElement.style.setProperty("--color-header", headerbackground);
          document.documentElement.style.setProperty("--color-footer", footercolor);
          document.documentElement.style.setProperty("--color-headertext", headertext);
          document.documentElement.style.setProperty("--color-primary1", primarycolor);
          document.documentElement.style.setProperty("--color-buttontext", send_button);
          document.documentElement.style.setProperty("--color-buttonbackground", accentColor);
          document.documentElement.style.setProperty("--color-chatbackground", wholesectionbackground);
          document.documentElement.style.setProperty("--color-bubbletext", bubble_Sender);

          // Set loading to false after everything is set
          setIsLoading(false);

        } else {
          // console.log("No such document!");
          setIsLoading(false);
        }
      } catch (error) {
        // console.error("Error fetching image: ", error);
        setIsLoading(false);
      }
    };

    fetchImage();
  }, [shopId]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === 'TOGGLE_CHAT_VISIBILITY') {
        setfloat_Visible(event.data.visible);
      }
    };

    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  // Send message to parent to control toggle button visibility
  useEffect(() => {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({
        type: 'TOGGLE_CHAT_VISIBILITY',
        visible: !float_visible // Hide toggle button when chat IS visible
      }, '*');
    }
  }, [float_visible]);

  // Don't render until colors are loaded
  if (isLoading) {
    return null; // Or return a simple loading spinner with inline styles

  }

 return (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      zIndex: 10,
      display: float_visible ? 'block' : 'none',
    }}
    className="krunk-bg-transparent"
  >
    <div className="krunk-flex krunk-justify-end md:krunk-justify-end krunk-items-end md:krunk-items-center krunk-h-full krunk-bg-transparent">
      {/* Mobile: items at bottom (krunk-items-end), Desktop: items centered (md:krunk-items-center) */}
      {float_visible && (
        <>
        {isGetMyCouch ? (
  // Widget for GetMyCouch - positioned at bottom-right on desktop, bottom navigation on mobile
  <div 
    className="krunk-fixed krunk-bottom-0 krunk-left-0 krunk-right-0 md:krunk-left-auto md:krunk-bottom-10 md:krunk-right-0 krunk-w-full md:krunk-w-[280px]"
    style={{
      zIndex: 1000
    }}
  >
    <div
      className="krunk-flex krunk-flex-row md:krunk-flex-col krunk-gap-2 md:krunk-gap-3 krunk-px-2 krunk-py-2 md:krunk-p-5 krunk-bg-white krunk-shadow-xl md:krunk-border md:krunk-border-gray-200"
      style={{
        borderTopLeftRadius: '24px',
        borderTopRightRadius: '24px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
      }}
    >
      <button
        onClick={handleVisitStore}
        className="krunk-flex-1 md:krunk-flex-none krunk-px-3 md:krunk-px-8 krunk-py-2.5 md:krunk-py-3 krunk-bg-white krunk-border-2 krunk-font-semibold krunk-transition-colors krunk-text-sm md:krunk-text-base krunk-whitespace-nowrap"
        style={{
          borderRadius: '50px',
          color: '#25D366',
          borderColor: '#25D366',
          minWidth: '0'
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#E8F5E9'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
      >
        Visit Store
      </button>
      <button
        onClick={handleWhatsAppClick}
        className="krunk-flex-1 md:krunk-flex-none krunk-px-3 md:krunk-px-8 krunk-py-2.5 md:krunk-py-3 krunk-text-white krunk-font-semibold krunk-transition-colors krunk-text-sm md:krunk-text-base krunk-whitespace-nowrap"
        style={{
          borderRadius: '50px',
          backgroundColor: '#25D366',
          minWidth: '0'
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#20BD5A'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#25D366'}
      >
        WhatsApp for Offers
      </button>
    </div>
    
    {/* Desktop-only rounded corners and shadow overlay */}
    <style jsx>{`
      @media (min-width: 768px) {
        .krunk-fixed > div {
          border-top-left-radius: 24px !important;
          border-bottom-left-radius: 24px !important;
          border-top-right-radius: 0px !important;
          border-bottom-right-radius: 0px !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
        }
      }
    `}</style>
  </div>
): (
                <div className="krunk-flex krunk-flex-col krunk-h-full krunk-w-full krunk-max-w-md">
          <ChatBot 
            imageurl={imageUrl} 
            subMenu={submenu} 
            title={title} 
            actionButtons={defualtMessages} 
            setfloat_Visible={setfloat_Visible} 
            float_visible={float_visible}
          />
        </div>
)}
        </>

      )}
    </div>
     {showPopup && (
        <div
    className="krunk-fixed krunk-inset-0 krunk-bg-black krunk-bg-opacity-50 krunk-flex krunk-items-center krunk-justify-center"
    style={{ zIndex: 2000 }}
    onClick={closePopup}
  >
          <div
            className="krunk-bg-white krunk-rounded-2xl krunk-p-6 krunk-max-w-md krunk-w-full krunk-m-4 krunk-shadow-2xl krunk-max-h-[90vh] krunk-overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="krunk-flex krunk-justify-between krunk-items-center krunk-mb-6">
              <h2 className="krunk-text-2xl krunk-font-bold krunk-text-gray-800">Visit GetMyCouch</h2>
              <button
                onClick={closePopup}
                className="krunk-text-gray-500 hover:krunk-text-gray-700 krunk-text-3xl krunk-leading-none krunk-w-8 krunk-h-8 krunk-flex krunk-items-center krunk-justify-center"
              >
                ×
              </button>
            </div>

            {/* Noida Store */}
            <div className="krunk-mb-6 krunk-pb-6 krunk-border-b krunk-border-gray-200">
              <h3 className="krunk-text-lg krunk-font-semibold krunk-text-gray-800 krunk-mb-2">
                Noida, Sector 75
              </h3>
              <p className="krunk-text-gray-600 krunk-mb-3 krunk-leading-relaxed">
                Plot No 8, Sector 75, Opposite Of Indosham 75 Apartment, Noida
              </p>
              <button
                onClick={() => handleGetDirections('noida')}
                className="krunk-text-blue-600 hover:krunk-text-blue-700 krunk-font-semibold krunk-underline krunk-transition-colors"
              >
                Get Directions
              </button>
            </div>

            {/* Gurgaon Store */}
            <div className="krunk-mb-6">
              <h3 className="krunk-text-lg krunk-font-semibold krunk-text-gray-800 krunk-mb-2">
                Gurgaon, Sector 52
              </h3>
              <p className="krunk-text-gray-600 krunk-mb-3 krunk-leading-relaxed">
                2nd Floor, Vishal Tower, Sector 52, Opposite Of Tau Devi Lal Park, Gurugram
              </p>
              <button
                onClick={() => handleGetDirections('gurgaon')}
                className="krunk-text-blue-600 hover:krunk-text-blue-700 krunk-font-semibold krunk-underline krunk-transition-colors"
              >
                Get Directions
              </button>
            </div>

            <button
              onClick={closePopup}
              className="krunk-w-full krunk-px-6 krunk-py-3 krunk-bg-gray-100 krunk-text-gray-700 krunk-rounded-lg krunk-font-semibold hover:krunk-bg-gray-200 krunk-transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      )}
  </div>
);
}
export default App;
